<template>
  <div class="iDalgo-Select-Dropdown" v-click-outside="clickOutside" v-bind:class="{ opened: opened }">
    <transition name="fade" mode="out-in">
      <ul class="choices" v-if="opened" v-bind:class="{ opened: opened }">
        <li
          v-for="(choice, key) in choices"
          v-bind:key="key"
          @click="select(choice)"
          v-bind:class="{ anim: opened }">
          {{ choice.title }}
        </li>
      </ul>
    </transition>
    <div class="select-btn" @click="open">
      {{ this.choices[0].title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'iDalgo-Select-Dropdown',
  props: ['choices', 'filter'],
  data () {
    return {
      opened: false
    }
  },
  methods: {
    select (choice) {
      this.opened = false
      // update only if the choice has changed
      if (choice.filter !== this.choices[0].filter) {
        this.choices.splice(0, 0, this.choices.splice(this.choices.indexOf(choice), 1)[0])
        this.$store.commit('players/FILTER_UPDATED', choice.filter)
      }
    },
    open () {
      this.opened = true
    },
    clickOutside () {
      this.opened = false
    }
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // check if the click was outside the el and its childrens
          if (!(el === event.target || el.contains(event.target))) {
            // call the method provided in the attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  }
}

</script>

<style lang="scss">
.iDalgo-Select-Dropdown {
  position: relative;
  height: 46px;
  width: 100%;

  ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 14px;
  }

  ul {
    position: absolute;
    z-index: 10;
    width: 100%;
    min-height: 46px;
    border-radius: 6px;
    overflow: hidden;
    background-color: #FFFFFF;
    cursor: pointer;
    box-shadow: 0 2px 12px 0 rgba(213,213,213,0.5);

    li {
      display: flex;
      align-items: center;
      height: 46px;
      padding-left: 20px;
      user-select: none;

      &:hover {
        background-color: #F5F5F5;
      }

      &:first-child {
        background-color: #F5F5F5;
      }
    }
  }

  .select-btn {
    z-index: 100;
    display: flex;
    align-items: center;
    height: 46px;
    margin: 0;
    padding-left: 20px;
    border-radius: 5px;
    background-color:$light-gray;
    user-select: none;
    cursor: pointer;
    font-size: 14px;
  }

  &::after {
    position: absolute;
    content: '';
    display: block;
    right: 20px;
    top: 19px;
    border-bottom: 6px solid $color1;
    border-left: 6px solid transparent;
    transform: rotate(45deg);
    z-index: 1000;
    pointer-events: none;
  }

  &.opened {
    &::after {
      transform: rotate(225deg);
      top: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Select-Dropdown.vue